exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dog-js": () => import("./../../../src/pages/dog.js" /* webpackChunkName: "component---src-pages-dog-js" */),
  "component---src-pages-helloworld-js": () => import("./../../../src/pages/helloworld.js" /* webpackChunkName: "component---src-pages-helloworld-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

